<footer>
  <div class="info">
    <div>
      <img src="./assets/logo-sped.jpg" class="logo">
    </div>
    <div>
        <h2>Escritório</h2>
        <p><i class="fa fa-phone"></i>Belo Horizonte: (31) 3519-7500</p>
        <p><i class="fa fa-phone"></i>São Paulo: (11) 5083-7771</p>
      </div>
    <div>
      <h2>Suporte Técnico</h2>
      <p><i class="far fa-file-pdf"></i> <a [href]="urlBlobPdf" target="_blank">FAQ - Perguntas Frequentes</a></p>
      <p>
        <i class="fa fa-user"></i> 
        <a target="_blank" rel="noopener noreferrer" href="https://contato.mastermaq.com.br/cliente/acesso"> Área do Cliente</a>
      </p>
      <p><br/></p>
      <p><br/></p>
    </div>
    <div>
        <ul>
            <li>
                <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/spedautomation"><i
                    class="fab fa-instagram"></i></a>
            </li>
            <li>
                <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/spedautomation"><i
                    class="fab fa-facebook"></i></a>
            </li>
            <li>
                <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/company/spedautomation"><i
                    class="fab fa-linkedin"></i></a>
            </li>
            <li>
                <a target="_blank" rel="noopener noreferrer" href="https://www.youtube.com/channel/UCWJJYO1w_qbTy-RsCki4A9Q"><i
                    class="fab fa-youtube"></i></a>
            </li>
        </ul>
    </div>
  </div>
  <div class="copyright">
    <p>
        <a target="_blank" rel="noopener noreferrer" href="https://www.spedautomation.com.br/">
            © {{ today.getFullYear() }} uma solução SPED Automation
        </a>
    </p>
  </div>
</footer>